module.exports = __webpack_public_path__ + "static/media/lexus-plus.cfa8f6fc.svg";